module.exports = __webpack_public_path__ + "static/icon-data-4385cf666dcd78d0447e9e1ac8b51949.svg";